<template lang="pug">
  .list-container
    .top-carousel
      v-img(:src="details.merchant_imageurl")
        v-layout(align-center justify-center fill-height slot="placeholder")
          v-progress-circular(indeterminate color="primary")
        v-dialog(
          width="500"
          scrollable
        )
          template(
            v-slot:activator="{on, attrs}"
          )
            v-btn(
              class="information-button"
              style="outline: none;"
              color="primary"
              depressed
              v-bind="attrs"
              v-on="on"
            )
              v-icon mdi-information-outline
              b.ml-2 Information
          v-card(
            height="30rem"
          )
            v-card
              v-card-title
                b Store Information
              template
                v-container(
                  :key="constraints.id"
                )
                  v-card-text(
                    v-if="(constraints.dinein_minimum !== '0.00' && constraints.dinein_minimum !== '0') || (constraints.dinein_extra !== '0.00' && constraints.dinein_extra !== '0')"
                  ) 
                    h3.header-title Dine In
                    p.text-md-body-1 Minimum Spending: {{ constraints.dinein_minimum }}
                    p.text-md-body-1 Extra Charges: {{ constraints.dinein_extra }}
                  v-card-text(
                    v-if="(constraints.reserve_minimum !== '0.00' && constraints.reserve_minimum !== '0') || (constraints.reserve_extra !== '0.00' && constraints.reserve_extra !== '0')"
                  ) 
                    h3.header-title Reservation
                    p.text-md-body-1 Minimum Spending: {{ constraints.reserve_minimum }}
                    p.text-md-body-1 Extra Charges: {{ constraints.reserve_extra }}
                  v-card-text(
                    v-if="(constraints.pickup_minimum !== '0.00' && constraints.pickup_minimum !== '0') || (constraints.pickup_extra !== '0.00' && constraints.pickup_extra !== '0')"
                  ) 
                    h3.header-title Pickup
                    p.text-md-body-1 Minimum Spending: {{ constraints.pickup_minimum }}
                    p.text-md-body-1 Extra Charges: {{ constraints.pickup_extra }}
                  v-card-text(
                    v-if="(constraints.delivery_minimum !== '0.00' && constraints.delivery_minimum !== '0') || (constraints.delivery_extra !== '0.00' && constraints.delivery_extra !== '0')"
                  ) 
                    h3.header-title Delivery
                    p.text-md-body-1 Minimum Spending: {{ constraints.delivery_minimum }}
                    p.text-md-body-1 Extra Charges: {{ constraints.delivery_extra }}
    //- v-sheet
    //-   h3.header-title Gallery
    //-   v-progress-circular(
    //-     v-if="loading"
    //-     indeterminate
    //-     color="primary"
    //-     :size="100"
    //-   )
    //-   v-slide-group(
    //-     v-else
    //-     class="gallery-container"
    //-     v-model="selected"
    //-     center-active
    //-     mobile-breakpoint="1264"
    //-   )
    //-     v-slide-item(
    //-       v-for="(i, index) in banner_list"
    //-       :key="index"
    //-       v-slot="{ active, toggle }"
    //-     )
    //-       v-card(
    //-         :color="active ? 'primary lighten-1' : 'white'"
    //-         class="mt-0 ml-0 ma-4 text-center gallery-item"
    //-         width="144"
    //-         @click="toggle"
    //-       )
    //-         v-img(
    //-           :src="i.banner_url"
    //-           aspect-ratio="1"
    //-           class="grey lighten-2"
    //-         )
    //-           template(v-slot:placeholder)
    //-             v-row(
    //-               class="fill-height ma-0"
    //-               align="center"
    //-               justify="center"
    //-             )
    //-               v-progress-circular(
    //-                 indeterminate
    //-                 color="grey lighten-5"
    //-               )
    //- v-sheet.merchant-gallery.hide-on-mobile
    //-   h3.header-title Gallery
    //-   v-progress-circular(
    //-     v-if="loading"
    //-     indeterminate
    //-     color="primary"
    //-     :size="100"
    //-   )
    //-   v-row(v-else)
    //-     v-col(
    //-       v-for="(i, index) in banner_list"
    //-       :key="index"
    //-       class="d-flex child-flex"
    //-       cols="6"
    //-     )
    //-       v-img(
    //-         :src="i.banner_url"
    //-         aspect-ratio="1"
    //-         class="grey lighten-2"
    //-       )
    //-         template(v-slot:placeholder)
    //-           v-row(
    //-             class="fill-height ma-0"
    //-             align="center"
    //-             justify="center"
    //-           )
    //-             v-progress-circular(
    //-               indeterminate
    //-               color="grey lighten-5"
    //-             )

    //- menu item and menu list for desktop view START
    v-sheet#merchant(v-if="!mobileView && !tabletView")
      h3.header-title Menu
      v-progress-circular(
        v-if="loading"
        indeterminate
        color="primary"
        :size="100"
      )
      v-row(
        v-else
        dense
      )
        v-col(cols="3")
          v-card(
            class="menu-card mx-auto mt-0 mb-4"
          )
            v-card-title
              span Category
            v-list(
              class="p-0"
              flat
            )
              v-list-item-group(
                v-model="selection"
              )
                template(v-for="(i, index) in menu_list")
                  v-list-item(
                    :key="index"
                    @click="jumpToItemCategory(i.menu_id)"
                  )
                    v-list-item-content
                      v-list-item-title
                        b {{ i.menu_name }}
                  v-divider.m-0
        v-col(cols="9")
          v-card(
            v-for="(i, index) in menu_list"
            :id="i.menu_id"
            :loading="loading"
            :key="index"
            class="menu-card mx-auto mt-0 mb-4"
          )
            //- template(slot="progress")
            //-   v-progress-linear(
            //-     color="primary"
            //-     height="10"
            //-     indeterminate
            //-   )
            //- .menu-image-container(
            //-   :style="{'background-image': `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.8)), url(${i.menu_imageurl})`}"
            //- )
            v-card-title
              span {{ i.menu_name }}
              //- p.font-weight-light {{ i.menu_description }}
            //- v-spacer
            v-list(
              class="p-0"
              two-line
              flat
            )
              v-list-item-group(
                v-model="selection"
                active-class="primary--text"
              )
                template(v-for="(x, index) in i.children")
                  v-list-item(
                    :class="x.item_inventory ? 'menu-item' : 'menu-no-stock'"
                    :key="x.item_id"
                    @click="selectItem(i, x)"
                  )
                    template(v-slot:default="{ active }")
                      v-list-item-icon(
                        class="menu-item-image"
                      )
                        img(
                          :src="x.item_imageurl"
                        )
                      v-list-item-content
                        v-list-item-title
                          b {{ x.item_name }}
                        v-list-item-subtitle {{ x.item_description }}
                      v-list-item-action
                        span(
                          :class="x.item_saleprice ? 'stroke-price' : ''"
                        ) RM {{ x.item_price }}
                        span(
                          class="sale-price"
                          v-if="x.item_saleprice"
                        ) RM {{ x.item_saleprice }}
                      //- v-list-item-action
                      //-   .d-flex.flex-row
                      //-     span X 0
                      //-     v-icon(
                      //-       color="red lighten-1"
                      //-     ) mdi-delete
                  v-divider(
                    class="m-0"
                    v-if="index < i.children.length - 1"
                    :key="index"
                  )
        StoreItem(
          id="item-card"
          v-if="selectedItem && selectedMenu"
          :dialog="dialog"
          :merchantId="merchantId"
          :storeId="storeId"
          :itemName="selectedItem.item_name"
          :menuId="selectedMenu.menu_id"
          :itemId="selectedItem.item_id"
          :itemStock="selectedItem.item_inventory"
          :constraints="constraints"
          @deselect="deselectItem"
        )

    //- menu item and menu list for desktop view END

    //- menu item for mobile and tablet view START
    v-sheet#merchant(v-else-if="mobileView || tabletView")
      h3.header-title Menu
      v-progress-circular(
        v-if="loading"
        indeterminate
        color="primary"
        :size="100"
      )
      v-card(
        v-else
        v-for="(i, index) in menu_list"
        :id="i.menu_id"
        :loading="loading"
        :key="index"
        class="menu-card mx-auto mt-0 mb-4"
      )
        v-card-title
          span {{ i.menu_name }}
        v-list(
          class="p-0"
          two-line
          flat
        )
          v-list-item-group(
            v-model="selection"
            active-class="primary--text"
          )
            template(v-for="(x, index) in i.children")
              v-list-item(
                :class="x.item_inventory ? 'menu-item' : 'menu-no-stock'"
                :key="x.item_id"
                @click="selectItem(i, x)"
              )
                template(v-slot:default="{ active }")
                  v-list-item-icon(
                    class="menu-item-image"
                  )
                    img(
                      :src="x.item_imageurl"
                    )
                  v-list-item-content
                    v-list-item-title
                      b {{ x.item_name }}
                    v-list-item-subtitle {{ x.item_description }}
                  v-list-item-action
                    span(
                      :class="x.item_saleprice ? 'stroke-price' : ''"
                    ) RM {{ x.item_price }}
                    span(
                      class="sale-price"
                      v-if="x.item_saleprice"
                    ) RM {{ x.item_saleprice }}
              v-divider(
                class="m-0"
                v-if="index < i.children.length - 1"
                :key="index"
              )
    StoreItem(
      id="item-card"
      v-if="selectedItem && selectedMenu"
      :dialog="dialog"
      :merchantId="merchantId"
      :storeId="storeId"
      :itemName="selectedItem.item_name"
      :menuId="selectedMenu.menu_id"
      :itemId="selectedItem.item_id"
      :itemStock="selectedItem.item_inventory"
      :constraints="constraints"
      @deselect="deselectItem"
    )
    //- menu item for mobile and tablet view END

    //- menu list for mobile and tablet view START
    v-dialog(
      scrollable
      max-width="600"
      v-model="menuDialog"
    )
      template(
        v-slot:activator="{ on, attrs }"
      )
        v-container.menu-list-container
          v-btn(
            style="box-shadow: 1px 1px 2px #f44334;"
            v-if="mobileView"
            v-bind="attrs"
            v-on="on"
            small
            rounded
            color="black"
          ) Menu
          v-btn(
            style="box-shadow: 1px 1px 2px #f44334;"
            v-else-if="tabletView"
            v-bind="attrs"
            v-on="on"
            rounded
            color="black"
          ) Menu
      template(
        v-slot:default="dialog"
      )
        v-card(v-if="menu_list.length" max-height="50vh")
          v-list(
              class="p-0"
              flat
            )
              v-list-item-group(
                v-model="selection"
              )
                template(v-for="(i, index) in menu_list")
                  v-list-item(
                    :key="index"
                    @click="jumpToItemCategory(i.menu_id)"
                  )
                    v-list-item-content
                      v-list-item-title.menu-list-dialog
                        b {{ i.menu_name }}
                  v-divider.m-0
        v-card(v-else-if="!menu_list.length")
          v-card-text.menu-list-dialog This store does not currently have any items.
            //- menu list for mobile and tablet view END
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import StoreItem from "@/views/dinein/StoreItem";

export default {
  components: {
    StoreItem
  },
  props: {
    details: Object,
    merchantId: String,
    storeId: String,
    constraints: Object
  },
  watch: {
    details: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$store.commit("layout/setDisplayTitle", val.store_name);
      }
    }
  },
  data() {
    return {
      dialog: false,
      menuDialog: false,
      selected: 0,
      banner_list: [],
      menu_list: [],
      selection: null,
      selectedMenu: null,
      selectedItem: null,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    mobileView() {
      return this.$vuetify.breakpoint.xs;
    },
    tabletView() {
      return this.$vuetify.breakpoint.sm;
    }
  },
  mounted() {
    this.getBannerList();
    this.getMenuList();
  },
  beforeDestroy() {
    this.deselectItem();
  },
  methods: {
    jumpToItemCategory(selectedItemCategory) {
      // var element = document.querySelector("#" + selectedItemCategory);
      // element.scrollIntoView({block: "start", inline: "nearest", behavior: "smooth"});

      var top = document.getElementById(selectedItemCategory).offsetTop + 230; // 230 to offset for fixed navbar height
      window.scroll({top: top, behavior: "smooth"});

      this.menuDialog = false;
    },
    selectItem(x, i) {
      this.selectedMenu = x;
      this.selectedItem = i;
      // $("#item-card").toggle();
      this.dialog = true;
    },
    deselectItem(x, i) {
      this.selectedMenu = null;
      this.selectedItem = null;
      this.selection = null;
      this.dialog = false;
      // $("#item-card").toggle();
    },
    selectStore(i) {
      console.log(i);
      this.$router.push({
        name: "Store",
        params: {
          store: i.store_id
        }
      });
    },
    loadMenu(data) {
      data.forEach((x, index) => {
        if (!this.menu_list.some(y => y.menu_id == x.menu_id))
          this.menu_list.push({
            menu_name: x.menu_name,
            menu_id: x.menu_id,
            menu_imageurl: x.menu_imageurl,
            menu_description: x.menu_description,
            children: []
          });

        var itemArray = this.menu_list.find(y => y.menu_id == x.menu_id)
          .children;

        if (!itemArray.some(z => z.item_id == x.item_id))
          itemArray.push({
            menu_id: x.menu_id,
            item_name: x.item_name,
            item_id: x.item_id,
            item_imageurl: x.item_imageurl,
            item_description: x.item_description,
            item_price: x.item_price,
            item_saleprice: x.item_onsale
              ? ((x.item_price * (100 - x.item_salepercent)) / 100).toFixed(2)
              : 0,
            item_inventory: x.item_inventory
          });
      });
    },
    getBannerList() {
      let url = config.bannerUrl();

      var json = {
        params: {
          merchant_id: this.merchantId,
          store_id: this.storeId,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.banner_list = JSON.parse(
                  JSON.stringify(response.body.data)
                );
              } else {
                this.$swal(
                  this.$t("error.get_merchant_banner"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_banner"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_banner"),
            response.body.message,
            "error"
          );
        });
    },
    getMenuList() {
      let url = config.menuUrl();

      var json = {
        params: {
          merchant_id: this.merchantId,
          store_id: this.storeId,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.loadMenu(response.body.data);
              } else {
                this.$swal(
                  this.$t("error.get_menu_list"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_menu_list"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_menu_list"),
            response.body.message,
            "error"
          );
        });
    }
  }
};
</script>
